import Http from '@/api/http.js'

export default {

  show(id) {
    return Http.get(`/assigned_vrt_payments/${id}`);
  },
  

}
